import PageHeader from "components/layout/PageHeader";

function Origination() {
  return (
    <>
      <PageHeader title="Origination" />
    </>
  );
}

export default Origination;
